import { useMutation } from '@tanstack/react-query'

import { RoutesPath, StorePersistKeys } from 'src/types'

import { useNavigation } from 'src/hooks/useNavigation'
import { useGetAllMaintenanceByCarNumber } from 'src/hooks/useGetAllMaintenanceByCarNumber'
import { useAppSelector } from 'src/hooks/useAppSelector'
import {
  addMaintenanceTrackingHistory,
  deleteMaintenanceHistoryItem,
  updateMaintenanceTrackingHistory,
} from 'src/api/Maintenance'

import { MaintenanceProps, UpdatePayload } from 'src/api/Maintenance/types'

export const useManageMaintenanceHistory = () => {
  const { navigateTo } = useNavigation()
  const { activeCar } = useAppSelector(state => state.user)

  function goToCars(): void {
    navigateTo(RoutesPath.MY_CARS)
  }

  const name = activeCar

  const {
    data: allMaintenanceHistory,
    isLoading: isLoadingGetAllMaintenanceHistory,
  } = useGetAllMaintenanceByCarNumber(name)

  const {
    mutate: addMaintenanceHistory,
    isLoading: isLoadingAddMaintenanceHistory,
  } = useMutation({
    mutationKey: [StorePersistKeys.MAINTENANCE_HISTORY, name],
    mutationFn: (payload: MaintenanceProps) =>
      addMaintenanceTrackingHistory({ payload, name }, goToCars),
  })

  const {
    mutate: updateMaintenanceHistory,
    isLoading: isLoadingUpdateMaintenanceHistory,
  } = useMutation({
    mutationKey: [StorePersistKeys.MAINTENANCE_HISTORY, name],
    mutationFn: (payload: UpdatePayload) =>
      updateMaintenanceTrackingHistory({ ...payload, name }),
  })

  const {
    mutate: deleteMaintenanceHistory,
    isLoading: isLoadingDeleteMaintenanceHistory,
  } = useMutation({
    mutationKey: [StorePersistKeys.MAINTENANCE_HISTORY, name],
    mutationFn: (id: string) => deleteMaintenanceHistoryItem({ id, name }),
  })

  return {
    allMaintenanceHistory,
    addMaintenanceHistory,
    updateMaintenanceHistory,
    deleteMaintenanceHistory,
    isLoadingGetAllMaintenanceHistory,
    isLoadingAddMaintenanceHistory,
    isLoadingUpdateMaintenanceHistory,
    isLoadingDeleteMaintenanceHistory,
    isLoadingGeneral:
      isLoadingGetAllMaintenanceHistory ||
      isLoadingAddMaintenanceHistory ||
      isLoadingUpdateMaintenanceHistory ||
      isLoadingDeleteMaintenanceHistory,
  }
}
